<template>
  <div class="audit-page" v-title data-title="全部课程|卓考网校课程试听">
    <main class="g-view-container">
      <detail-navbar class="detail-navbar" />
      <detail-banner :images="banner" />
      <detail-info :title="title" :sales="sales" />
      <detail-service />

      <van-tabs class="my-tabs" :before-change="beforeChange">
        <van-tab title="详情">
          <detail-images :images="imageList" />
        </van-tab>
        <van-tab title="试听">
          <detail-catalog />
        </van-tab>
        <van-tab title="评论">
          <detail-comment />
        </van-tab>
      </van-tabs>
    </main>

    <aside>
      <detail-ball v-if="showBall" class="detail-ball" />
    </aside>

    <footer v-if="product" class="g-footer-container">
      <detail-pay :product="product" />
    </footer>
  </div>
</template>

<script>
  import axios from 'axios';
  import DetailNavbar from './detail-navbar';
  import DetailBanner from './detail-banner';
  import DetailInfo from './detail-info';
  import DetailService from './detail-service';
  import DetailImages from './detail-images';
  import DetailCatalog from './detail-catalog';
  import DetailComment from './detail-comment';
  import DetailPay from './detail-pay';
  import DetailBall from './detail-ball';

  export default {
    name: 'AuditDetail',
    components: {
      DetailNavbar,
      DetailBanner,
      DetailInfo,
      DetailService,
      DetailImages,
      DetailCatalog,
      DetailComment,
      DetailPay,
      DetailBall,
    },
    data() {
      return {
        title: '', // 标题
        sales: 0, // 销量
        banner: [], // banner图片列表
        imageList: [], // 详情页图片列表
        product: null,
        showBall: false, // 是否显示球
      };
    },

    created() {
      this.showBall = +this.$route.query.contact === 1;

      this.showLoading();
      this.getInfo(this.$route.params.listenIndexId).then(
        ({ data: { code, data } }) => {
          if (code === 200) {
            this.hideLoading();
            this.title = `${data.indexName}【${data.courseName}】`;
            this.sales = data.sales;
            this.banner = data.listenBanner.filter(item => item.type === 1);
            this.imageList = data.listenBanner.filter(item => item.type === 2);
            this.product = data.listenCourse;
          }
        },
      );
    },
    methods: {
      getInfo(id) {
        return axios.get(
          `https://api.zhuokao360.com/listen/findList?listenIndexId=${id}`,
        );
      },

      beforeChange(index) {
        let id = (this.$route.params.listenIndexId).toString();
        if (id === '101' || id === '106') {
          id = id.charAt(2);
        }
        if (id === '22') {
          id = id.charAt(1);
        }
        if (index === 1 && ['1', '2', '3', '6'].includes(id)) {
          window.location.href = `https://vip.zhuokao360.com/trial-class/index.html?professionId=${id}`;
          return false;
        }
        return true;
      },
    },
  };
</script>

<style lang="scss" scoped>
.detail-navbar {
  position: absolute;
  z-index: 1;
  width: 100%;
}

/* Tabs */
.my-tabs {
  margin-top: 5px;
}

.my-tabs .van-tab__pane {
  margin-top: 5px;
}

.van-tabs__line {
  z-index: 0;
}

.detail-ball {
  position: fixed;
  right: 20px;
  bottom: 90px;
  z-index: 100;
}
</style>
